import store from 'store'
import { integrationsFilter } from './helper'

const getKey = (campaignId) => {
  return `perspective.${campaignId}.tracking_preferences`
}

export const getPreferences = (campaignId) => {
  return store.get(getKey(campaignId))
}

export const exists = (campaignId) => {
  return !!getPreferences(campaignId)
}

export const setPreferences = (campaignId, preferences) => {
  return store.set(getKey(campaignId), preferences)
}
